exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.push([module.id, "@import url(http://fonts.googleapis.com/css?family=Roboto);", ""]);

// module
exports.push([module.id, "navbar{height:100%;background-color:#efefef;padding:1rem 0;flex:2;box-sizing:border-box}navbar .nav-links a{box-sizing:border-box;color:#0277bd;font-size:1.2rem;display:block;text-decoration:none;width:100%;padding:16px 8px;border-bottom:1px solid rgba(0,0,0,.12)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./client/app/common/navbar/navbar.scss
// module id = 454
// module chunks = 0